import React, { Component } from 'react';
import { api } from '../../api/api';
import { Alert, AlertErro } from '../../../util/Alertas';
import { IoMdClose } from "react-icons/io";
import { FaDownload } from "react-icons/fa";

class ProdutosSinteticos extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.Open = () => {
            api.get("api/pedidos/BuscarPedidosSinteticos", res => {
                const { cabecalho, rows, total } = res.data;
                this.setState({
                    cabecalho,
                    rows,
                    total,
                    show: true
                });
                this.toggleOverFlow(true);
            }, err => {
                console.log(err);
                AlertErro(err, 'Houve um erro ao buscar os dados');
            });
        }
    }

    initialState = {
        cabecalho: [],
        rows: [],
        total: "",
        show: false,
        currentPage: 1,
        itemsPerPage: 10,
        selectedOrder: 'Pedido'
    }

    toggleOverFlow = (show) => {
        document.body.style.overflow = show ? 'hidden' : 'auto'
    }

    handleDownloadCSV = () => {
        const { cabecalho, rows, total } = this.state;

        let csvContent = "\uFEFF"; // Adiciona o BOM para UTF-8

        // Adiciona os cabeçalhos
        csvContent += cabecalho.join(";") + "\n";

        // Adiciona as linhas da tabela
        rows.forEach(row => {
            csvContent += row + "\n";
        });

        // Adiciona a linha de total
        csvContent += total + "\n";

        // Cria um Blob com a codificação correta
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Cria um link para download
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "tabela_pedidos.csv");
        document.body.appendChild(link);

        // Simula o clique para iniciar o download
        link.click();

        // Remove o link após o download
        document.body.removeChild(link);
    };


    handleClose = () => { this.setState(this.initialState); this.toggleOverFlow(false); }

    buscarPedidosSinteticos = () => {
        api.get("api/pedidos/BuscarPedidosSinteticos", res => {
            const { cabecalho, rows, total } = res.data;
            this.setState({
                cabecalho,
                rows,
                total,
                show: true
            });
        }, err => {
            console.log(err);
            AlertErro(err, 'Houve um erro ao buscar os dados');
        });
    };

    handlePageChange = (newPage) => {
        this.setState({ currentPage: newPage });
    };

    formatNumber = (num) => {
        const parsedNum = parseFloat(num);
        return isNaN(parsedNum) ? num : parsedNum.toLocaleString("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };

    sortRows = (rows) => {
        const { selectedOrder } = this.state;

        return [...rows].sort((a, b) => {
            const aCols = a.split(";");
            const bCols = b.split(";");

            const firstCol = 0;
            const lastCol = aCols.length - 1;
            const secondLastCol = aCols.length - 2;

            let colIndexes = [];

            switch (selectedOrder) {
                case "Todos":
                    colIndexes = [firstCol, secondLastCol, lastCol];
                    break;
                case "Status":
                    colIndexes = [lastCol];
                    break;
                case "Cidade":
                    colIndexes = [secondLastCol];
                    break;
                case "Pedido":
                    colIndexes = [firstCol];
                    break;
                default:
                    return 0;
            }

            for (let col of colIndexes) {
                if (aCols[col] !== bCols[col]) {
                    return aCols[col].localeCompare(bCols[col], "pt-BR", { numeric: true });
                }
            }
            return 0;
        });
    };

    handleSortChange = (event) => {
        this.setState({ selectedOrder: event.target.value });
    };

    render() {
        const { cabecalho, rows, total, show, currentPage, itemsPerPage, selectedOrder } = this.state;
        if (!show) return null;

        // Paginação
        const sortedRows = this.sortRows(rows);
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentRows = sortedRows.slice(indexOfFirstItem, indexOfLastItem);
        const totalPages = Math.ceil(sortedRows.length / itemsPerPage);

        return (
            <div style={{
                position: 'fixed'
                , background: '#fff'
                , width: '100%'
                , height: '100%'
                , zIndex: '1000'
                , top: '0'
                , left: '0'
                , padding: '2.5rem'
                , overflow: 'auto'
            }}>
                <div style={{ display: 'flex', justifyContent: "end", alignItems: "center" }}>
                    <button onClick={this.handleClose} className='btn btn-primary'><IoMdClose /></button>
                </div>
                <br />
                <div className='row'>
                    <div className="col-md-3">
                        <label>Organizar Por:</label>
                        <select className='form-control' onChange={this.handleSortChange} value={selectedOrder}>
                            <option>Status</option>
                            <option>Cidade</option>
                            <option>Pedido</option>
                        </select>
                    </div>
                    <div className="col-md-3" style={{ marginTop: '22px' }}>
                        <button onClick={this.handleDownloadCSV} className='btn btn-primary'><FaDownload /> Download</button>
                    </div>
                </div>
                <br />
                <table className='table table-striped table-bordered'>
                    <thead>
                        <tr>
                            {cabecalho.map((item, index) => (
                                <th style={{ background: "var(--cor-principal)", color: "#fff", textAlign: "center" }} key={index}>{item}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {currentRows.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                {row.split(";").map((item, colIndex) => (
                                    <td data-label={cabecalho[colIndex]} style={{ textAlign: "center" }} key={colIndex}>{item}</td>
                                ))}
                            </tr>
                        ))}
                        <tr>
                            {total.split(";").map((item, index) => (
                                <td data-label={index === 0 ? '' : cabecalho[index]} style={{ background: "var(--cor-principal)", color: "#fff", textAlign: "center" }} key={index}>{this.formatNumber(item)}</td>
                            ))}
                        </tr>
                    </tbody>
                </table>

                {/* Paginação */}
                <div className="pagination">
                    <button
                        className='btn btn-primary'
                        onClick={() => this.handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Anterior
                    </button>
                    <span>Página {currentPage} de {totalPages}</span>
                    <button
                        className='btn btn-primary'
                        onClick={() => this.handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Próxima
                    </button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <small>Total: {rows.length}</small>
                </div>
            </div>
        );
    }
}

export default ProdutosSinteticos;
